var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRetakeIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0504 19.9508C6.15039 19.9508 2.60039 17.6508 1.00039 14.1508L2.30039 13.5508C3.70039 16.5508 6.75039 18.5008 10.0504 18.5008C14.7504 18.5008 18.5504 14.7008 18.5504 10.0008C18.5504 5.30078 14.7504 1.50078 10.0504 1.50078C6.50039 1.50078 3.50039 3.70078 2.25039 7.20078L0.900391 6.70078C2.35039 2.65077 5.90039 0.0507812 10.0504 0.0507812C15.5504 0.0507812 20.0004 4.50078 20.0004 10.0008C20.0004 15.5008 15.5004 19.9508 10.0504 19.9508Z",
    fill: "#714FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2 7.70078H0V1.55078H1.55V6.15077H6.2V7.70078Z",
    fill: "#714FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetakeIcon);
export default __webpack_public_path__ + "static/media/retake-icon.9776fae2b768a5e0b2d1830978cb898e.svg";
export { ForwardRef as ReactComponent };